import React from "react";
import PublicSeoHub from "./PublicSeoHub";

export default function RegulationsHub() {
  return <PublicSeoHub type="regulations" />;
}